import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CLARITY_PROJECT_ID = "yaes1nbm5f";

declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

let loaded = false;

function injectClarity(): void {
  if (loaded) return;
  loaded = true;

  try {
    const w = window as unknown as {
      clarity?: (...args: unknown[]) => void;
    };

    w.clarity =
      w.clarity ||
      function (...args: unknown[]) {
        const q = (w.clarity as unknown as { q?: unknown[] }).q || [];
        q.push(args);
        (w.clarity as unknown as { q?: unknown[] }).q = q;
      };

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
    const first = document.getElementsByTagName("script")[0];
    if (first && first.parentNode) {
      first.parentNode.insertBefore(script, first);
    } else {
      document.head.appendChild(script);
    }
  } catch {
    // ignore tracking failures silently
  }
}

export default function ClarityTracking() {
  const location = useLocation();

  useEffect(() => {
    injectClarity();
  }, []);

  useEffect(() => {
    try {
      if (window.clarity) {
        window.clarity("set", "path", location.pathname + location.search);
      }
    } catch {
      // ignore tracking failures silently
    }
  }, [location.pathname, location.search]);

  return null;
}